module.exports = __webpack_public_path__ + "img/timesheet-log-book_B09NGVLNRQ.8d1a53c1.jpg";